import {MediaMatcher} from '@angular/cdk/layout';
import { Component, OnInit, inject, signal} from '@angular/core';

import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { Amplify } from 'aws-amplify';
import outputs from '../../amplify_outputs.json';

import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';

import { AmplifyAuthenticatorModule, AuthenticatorService } from '@aws-amplify/ui-angular';
import { AmplifyModelService } from './services/amplify-model-service.service';
import { NavigationService } from './services/navigation.service';
import { filter } from 'rxjs/operators';

Amplify.configure(outputs);
const existingConfig = Amplify.getConfig();
Amplify.configure({
  ...existingConfig,
  API: {
    ...existingConfig.API,
    REST: outputs.custom.API,
  },
});

/**New push for new token */
// template url: https://icolorpalette.com/1a522e_779e4f_70462c_f3e8d2_303030
/**New push for new token 3/20/26 */

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    imports: [
    RouterOutlet
]
})
export class AppComponent implements OnInit {
  title = 'amplify-angular-template';
  
  private authService = inject(AmplifyModelService);
  private navigationService = inject(NavigationService);
  private router = inject(Router);

  async ngOnInit() {
    // Listen for route changes to handle post-login redirects
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(async (event: NavigationEnd) => {
      console.log('🔄 Navigation completed to:', event.url);
      await this.handleAuthenticationRedirect();
    });

    // Initial check
    await this.handleAuthenticationRedirect();
  }

  private async handleAuthenticationRedirect() {
    try {
      console.log('🔐 Checking authentication status...');
      const user = await this.authService.getCurrentUser();
      console.log('👤 Current user:', user);
      
      if (user) {
        console.log('✅ User authenticated');
        console.log('📍 Current URL:', this.router.url);
        
        // Only redirect if on login page (after successful login)
        // Don't redirect from homepage - let users access it even when authenticated
        if (this.router.url === '/login') {
          console.log('🔍 Getting user groups for redirect...');
          const groups = await this.authService.getUserGroups();
          const defaultRoute = this.navigationService.getDefaultRouteForGroups(groups);
          console.log('🔄 Redirecting authenticated user from login to:', defaultRoute);
          this.router.navigate([defaultRoute]);
        } else {
          console.log('ℹ️ User authenticated but not on login page, not redirecting');
        }
      } else {
        console.log('🚫 No authenticated user found');
        
        // If user is trying to access protected routes without authentication, redirect to login
        if (this.router.url.startsWith('/dashboard')) {
          console.log('🔄 Redirecting unauthenticated user to login');
          this.router.navigate(['/login']);
        }
      }
    } catch (error) {
      // User not authenticated
      console.log('🚫 User not authenticated');
      console.log('Error details:', error);
      
      // If user is trying to access protected routes without authentication, redirect to login
      if (this.router.url.startsWith('/dashboard')) {
        console.log('🔄 Redirecting unauthenticated user to login');
        this.router.navigate(['/login']);
      }
    }
  }
}
